import React, { useState } from 'react';
import styles from './style.module.css';
import { ShowcaseImageMiddle } from '../assets/webp';
import Typography from '../components/Typography/Typography';
import FlatButtons from '../components/FlatButton/FlatButton';
import { openXfacebookDark, openXinstagramDark, openXlinkedinDark, openXtwitterDark, openXyoutubeDark } from '../assets/socials';
import { useCreateContactMessageMutation } from '../redux/services/contactApi';
import AnimatedCard from '../components/AnimatedCard';
import AnimatedButton from '../components/AnimatedButton';

interface ContactForm {
  name: string;
  email: string;
  message: string;
}

export const ContactPage: React.FC = () => {
  const [formData, setFormData] = useState<ContactForm>({
    name: '',
    email: '',
    message: ''
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [ createContactMessage ] = useCreateContactMessageMutation();
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    // Handle form submission logic here
    // console.log('Form submitted:', formData);

          if (!formData.name.trim()) {
            setErrorMessage('• Name is required.');
            return;
          }

          if (!isValidEmail(formData.email)) {
            console.log('• Email must be a valid email address');
            setErrorMessage('• Email must be a valid email address');
            // setIsLoading(false);
            return;
          }

          if (!formData.message.trim()) {
            setErrorMessage('• Message is required.');
            return;
          } else if (formData.message.length < 10) {
            setErrorMessage('• Message must be at least 10 characters.');
            return;
          }

          setIsLoading(true)

    try
    {
      const response = await createContactMessage(
      {
        name: formData.name,
        email: formData.email,
        message: formData.message
      }).unwrap()
      console.log(response)
      setErrorMessage("");
      setFormData({name: '', email: '', message: ''});
    }
    catch (err: any) 
    {
      console.error('Failed:', err);
      const errorMessage = err.data?.message || 'Invalid credentials. Please try again.';
      setErrorMessage(errorMessage);
    }
    finally
    {
      setIsLoading(false)
    }
    
  };
  
      function isValidEmail(email: string): boolean {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    }


  return (
    <div className={styles.contactContainer}>
      <div className={styles.contactContent}>
        <div className={styles.leftSection}>
          <div className={styles.headerSection}>
            <Typography
              variant='heading2'
              fontFamily='satoshi'
              weight='bold'
              className={styles.contactTitle}>
              Got Some Questions For Us? Contact Us
            </Typography>
          </div>

          <div className={styles.contactForm}>
            <div className={styles.formGroup}>
              <label htmlFor="name" className={styles.formLabel}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  size='base'
                  className={styles.formLabelText}
                >
                  Name
                </Typography>
              </label>
              <Typography
                variant='bodyRegular'
                fontFamily='satoshi'
                size='base'
                className={styles.inputText}>
                <input
                  type="text"
                  id='name'
                  name="name"
                  className={styles.formInput}
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </Typography>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email" className={styles.formLabel}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  size='base'
                  className={styles.formLabelText}
                >
                  Email
                </Typography>
              </label>
              <Typography
                variant='bodyRegular'
                fontFamily='satoshi'
                size='base'
                className={styles.inputText}>
                <input
                  type="email"
                  id='email'
                  name="email"
                  className={styles.formInput}
                  placeholder="johndoe@gmail.com"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </Typography>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message" className={styles.formLabel}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  size='base'
                  className={styles.formLabelText}
                >
                  Message
                </Typography>
              </label>
              <Typography
                variant='bodyRegular'
                fontFamily='satoshi'
                size='base'
                className={styles.inputText}>
                <textarea
                  name="message"
                  id='message'
                  className={styles.formTextarea}
                  placeholder="Write your message here"
                  rows={6}
                  value={formData.message}
                  onChange={handleInputChange}
                />
              </Typography>
              <div className={styles.errMsg}>{errorMessage}</div>
            </div>

            <AnimatedButton
            variant='primary'
              type="submit"
              className={styles.submitButton}
              disabled={isLoading}
              onClick={() => handleSubmit({ preventDefault: () => { } } as React.FormEvent<HTMLFormElement>)}
            >
              <Typography
                variant='buttonText'
                fontFamily='satoshi'
                size='base'
                className={styles.submitButtonText}>
                 
                 {isLoading ? "Sending..." : "Send Message"}
              </Typography>
            </AnimatedButton>
          </div>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.infoSection}>
            <Typography
              variant='bodyRegular'
              fontFamily='satoshi'
              weight='regular'
              className={styles.infoText}>
              Whether you're an artist with a question, a collector seeking support,
              or a partner interested in collaboration, the OpenX team is here to help.
            </Typography>

            <div className={styles.contactInfo}>
              <div className={styles.contactDetail1}>
                <div
                  className={styles.contactPhone}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.contactPhoneText}>
                    +234 815 053 9392
                  </Typography>
                </div>

                <div className={styles.socialLinks}>
                  <a href="hello#" className={styles.socialLink} aria-label="Twitter">
                    <img src={openXtwitterDark} alt="Twitter" width="20" height="20" />
                  </a>
                  <a href="hello#" className={styles.socialLink} aria-label="YouTube">
                    <img src={openXyoutubeDark} alt="YouTube" width="20" height="20" />
                  </a>
                  <a href="hello#" className={styles.socialLink} aria-label="Instagram">
                    <img src={openXinstagramDark} alt="Instagram" width="20" height="20" />
                  </a>
                  <a href="hello#" className={styles.socialLink} aria-label="LinkedIn">
                    <img src={openXlinkedinDark} alt="LinkedIn" width="20" height="20" />
                  </a>
                  <a href="hello#" className={styles.socialLink} aria-label="Facebook">
                    <img src={openXfacebookDark} alt="Facebook" width="20" height="20" />
                  </a>
                </div>
              </div>

              <div className={styles.contactDetail2}>
                <div className={styles.addressInfo}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.addressText}>
                    kilometre 7, Enugu/Port Harcourt Expressway,
                    Centenary, Ugwuaji Enugu.
                  </Typography>
                </div>
                <div className={styles.emailInfo}>
                  <Typography
                    variant='bodyRegular'
                    fontFamily='satoshi'
                    weight='regular'
                    size='base'
                    className={styles.emailInfoText}>
                    hello@OpenX.com
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.gallerySection}>
            <img
              src={ShowcaseImageMiddle}
              alt="Gallery"
              className={styles.gallerySectionPhoto}
            />
          </div>
        </div>
      </div>
    </div>
  );
};